import PropTypes from 'prop-types';
import React from 'react';
import { valueSelector } from '../selectors';
import entityComposition from '../../common/classes/entityComposition';

// Add style properties to text
const textWrappers = (textStyle, text) => {
  // supported styles - add additional style by style key
  const supportedStyles = {
    bold: words => /*#__PURE__*/React.createElement("b", null, words),
    italic: words => /*#__PURE__*/React.createElement("i", null, words),
    paragraph: words => /*#__PURE__*/React.createElement("p", null, words),
    sectionHeader: words => /*#__PURE__*/React.createElement("h2", null, words),
    rightAligned: words => /*#__PURE__*/React.createElement("span", {
      style: {
        float: 'right'
      }
    }, words),
    uppercase: words => /*#__PURE__*/React.createElement("span", {
      style: {
        textTransform: 'uppercase'
      }
    }, words)
  };
  const style = Object.keys(supportedStyles).includes(textStyle) ? textStyle : 'paragraph';
  return supportedStyles[style](text);
};

/**
 * @class Text
 */
const Text = _ref => {
  let _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    _ref$displayText = _ref.displayText,
    displayText = _ref$displayText === void 0 ? '' : _ref$displayText,
    _ref$divider = _ref.divider,
    divider = _ref$divider === void 0 ? false : _ref$divider,
    _ref$textStyle = _ref.textStyle,
    textStyle = _ref$textStyle === void 0 ? 'paragraph' : _ref$textStyle;
  // default to staticly defined text, if that's empty try the contentPath value
  const text = displayText.length > 0 ? displayText : value;
  return text.length ? /*#__PURE__*/React.createElement(React.Fragment, null, textWrappers(textStyle, text), divider && /*#__PURE__*/React.createElement("hr", null)) : null;
};
Text.propTypes = {
  value: PropTypes.string,
  displayText: PropTypes.string,
  textStyle: PropTypes.string,
  divider: PropTypes.bool
};
export { Text as UncomposedText };
export default entityComposition(Text, [], {
  value: valueSelector
});